import { object } from "yup";
import {
  AdultsPrivacySchema,
  EmailSchema,
  PasswordSchema,
  TermsOfUseSchema,
  UsernameSchema,
} from "@validation/user";
import { ReferralSchema } from "@validation/common";

export const initialValues = {
  username: "",
  email: "",
  password: "",
  referral: "",
  isAcceptedTermsAndPrivacy: false,
  isAdultConfirmation: false,
};

export const validationSchema = object().shape({
  username: UsernameSchema,
  email: EmailSchema,
  password: PasswordSchema,
  isAcceptedTermsAndPrivacy: TermsOfUseSchema,
  isAdultConfirmation: AdultsPrivacySchema,
  referral: ReferralSchema,
});
